import { Content } from "./content";
import { Media } from "./media";

export interface Post extends AllPosts {
    campaignId: string;
    scheduleId: string;
    content: string | string[];
    contentIds?: Content[];
    media: Media[];
    caption?: string;
    footer?: string;
    includeFooter?: boolean;
    footerType?: "comment" | "in-post";
    /** The X text was written as its own tweets (a blank line between them); the preview keeps those breaks. */
    threadComposed?: boolean;
    displayName?: string;
    socialId?: string;
    pageName?: string;
    socialPlatform?: string;
    profileUrl?: string;
    userImage?: string;
    username?: string;
    manual?: boolean;
    background?: {
        type: 'solid' | 'gradient';
        color?: string;
        from?: string;
        to?: string;
        direction?: string;
    };
    textColor?: string;
    fontSize?: number;
    fontFamily?: string;
    imageText?: string;
    youtubeTags?: string[];
    youtubeHashtags?: string[];
    postTime?: string;
    postUrl?: string;
    // MB-1314: set only on an automatically generated video post — the slideshow render
    // its video came from. Its presence is what makes the caption editor available.
    slideshowJobId?: string;
    // MB-1460: present on every Caption Video (ZapCap) family post — the GCS
    // path of the retained pre-caption original. Its presence is what makes
    // the ZapCap caption editor available.
    zapcapOriginalVideoUrl?: string;
    zapcapTranscript?: string;
}

export enum ContentLength {
    Short = "Short",
    Medium = "Medium",
    Long = "Long",
}

export enum ZapcapVideoStatus {
    Processing = "processing",
    Ready = "ready",
    Failed = "failed",
}

export interface AllPosts {
    id: string;
    scheduledFor: string;
    color: string;
    contentType: string;
    status: string;
    platform: string;
    type: string;
    address?: string;
    contentLength: ContentLength;
    title?: string;
    /** ZapCap captioning lifecycle, independent of the post's overall status. */
    zapCapVideoStatus?: ZapcapVideoStatus;
    /** MB-1399: published in developer testing mode — never reached Ayrshare. */
    simulated?: boolean;
    /** MB-1274: this Scheduled post will be auto-enriched with open-house
     * info when it publishes — the calendar swaps the status dot for a
     * house glyph. Scheduled only: a Retrying post is enriched too but is
     * deliberately left unflagged by the api (see open-house-indicator.util.ts
     * in marabot-api). Only the calendar feed sets it. */
    hasUpcomingOpenHouses?: boolean;
}
